export default __webpack_public_path__ + "static/media/games_icon.7ade2069.svg";